import * as React from "react";
import { connect } from "react-redux";
import { selectCoopProjects } from "../../../balancingSelectors/selectBalancingCoopProjects";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopProjectBuffedLoyalty } from "../../../selectors/selectBuffsInfo";
import { selectCoopActiveProject, selectCoopMemberProjectInfo, selectCoopProjectRankingInformation, selectCoopSelectedProjectTypeId, } from "../../../selectors/selectCoopInfo";
import { actionCoopProjectInfoClear } from "../actionCoop";
import { CoopProjectInformation } from "./CoopProjectInformation";
import { CoopProjectProgress } from "./CoopProjectProgress";
import { CoopProjectStart } from "./CoopProjectStart";
import { ProjectOverview } from "./ProjectOverview";
var _DetailViewCoopProjects = function (_a) {
    var activeCoopProject = _a.activeCoopProject, projectPointsOverview = _a.projectPointsOverview, selectedCoopProjectId = _a.selectedCoopProjectId, onOverviewClose = _a.onOverviewClose, rankingRewards = _a.rankingRewards, loyaltyBoost = _a.loyaltyBoost;
    var projects = selectCoopProjects();
    var selectedCoopProject = getProject(projects, selectedCoopProjectId);
    if (!selectedCoopProject) {
        return React.createElement(React.Fragment, null);
    }
    if (projectPointsOverview !== undefined && rankingRewards.length > 0) {
        return (React.createElement(ProjectOverview, { loyaltyBoost: loyaltyBoost, memberPointInfo: projectPointsOverview, onClose: onOverviewClose, rankingRewards: rankingRewards }));
    }
    var contentAction = activeCoopProject && selectedCoopProject.id === activeCoopProject.typeId ? (React.createElement(CoopProjectProgress, { coopProject: selectedCoopProject })) : (React.createElement(CoopProjectStart, { coopProject: selectedCoopProject }));
    return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
        React.createElement("div", { className: "coop-projects__detail-view " + IdStyles.DetailView },
            React.createElement(CoopProjectInformation, { coopProject: selectedCoopProject }),
            contentAction)));
};
var getProject = function (projects, coopProjectId) {
    var result;
    if (projects && projects.length > 0 && coopProjectId > -1) {
        result = projects.find(function (project) { return project.id === coopProjectId; });
    }
    return result;
};
var mapState = function (state) {
    var activeCoopProject = selectCoopActiveProject(state);
    var projectPointsOverview = activeCoopProject !== undefined ? selectCoopMemberProjectInfo(state) : undefined;
    return {
        activeCoopProject: activeCoopProject,
        loyaltyBoost: function (baseAmount) { return selectCoopProjectBuffedLoyalty(state, baseAmount); },
        projectPointsOverview: projectPointsOverview,
        rankingRewards: selectCoopProjectRankingInformation(state),
        selectedCoopProjectId: selectCoopSelectedProjectTypeId(state),
    };
};
var mapDispatch = function (dispatch) {
    return {
        onOverviewClose: function () { return dispatch(actionCoopProjectInfoClear()); },
    };
};
export var DetailViewCoopProjects = connect(mapState, mapDispatch)(_DetailViewCoopProjects);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DetailViewCoopProjects.tsx
// module id = 2589
// module chunks = 3